import { Component, OnInit } from '@angular/core';
import { Brand } from './brand';
import { BrandService } from './brand.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { UtilityService } from  '../utility.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { brand } from '@angular/animations';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.css']
})
export class BrandComponent implements OnInit {
  
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  brandForm: FormGroup;
 
  brand = new Brand();
  branddata : any = {}
  brands: Brand[];
  submitted = false;
  message: string;
  totalrecord : number;
  public isupdate = false;
  public FormName = "Add Brand";
  brandFilter: any = { brandname: '' };
  public brandid : number =0;

  constructor(
    private brandService: BrandService,
    private route: ActivatedRoute,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.brand.active = 1;
    this.getBrands();
    this.brandForm = this.formBuilder.group({			
      brandname: [this.brand.brandname,[Validators.required, Validators.required]],
      active: [this.brand.active,[Validators.required, Validators.required]]
    });	

  }

  
// convenience getter for easy access to form fields
get f() {
  return this.brandForm.controls
  }

onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.brandForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{    
    if(this.isupdate){
      this.brandForm.get('brandname').clearValidators();
			this.brandForm.get('brandname').updateValueAndValidity();
      this.update();
    }
    else{
      this.addBrand();
    }
  }
}

addBrand() {
  this.brandForm.get('brandname').clearValidators();
  this.brandForm.get('brandname').updateValueAndValidity();
   this.save();
 }
 
  private save(): void {
    this.branddata = this.brand;
    this.brandService.addBrand(this.branddata)
        .subscribe(() => {
		this.util.showSuccess("Brand added successfully.");
     this.brand = new Brand(); 
     this.getBrands();
		});
     this.isupdate= false;
  } 

  update(): void {
    this.submitted = true;
    this.branddata = this.brand;
    this.brandService.updateBrand(this.branddata)
        .subscribe(() => 
		{
		this.util.showSuccess("Brand update successfully.");
        this.brand = new Brand(); 
        this.isupdate= false;
        this.getBrands();
		});
        this.FormName ="Add Brand";
  }

  delete(brandid): void {
    this.submitted = true;
    this.brandService.deleteBrand(brandid)
        .subscribe(()=> this.message = "Brand Deleted Successfully!");
  }
 
  goBack(): void {
    this.location.back();
  }

  getBrands() {
    this.spinnerService.show();
    return this.brandService.getBrands()
               .subscribe(
                brands => {                
                  this.brands = brands
                  this.spinnerService.hide();
				          this.totalrecord =  this.brands.length;
                 }
                );
 }
 getBrand(brandid) {
  return this.brandService.getBrand(brandid)
             .subscribe(
               brand => {               
                this.FormName ="Update Brand";
                 this.brand = brand;
                 this.isupdate=true;
               }
              );
}


  public onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage*(pageNum - 1);
  }

  public changePagesize(num: number): void {
  this.itemsPerPage = this.pageSize + num;
  }


}
